export default {
  precipitateResultId: { field: 'precipitateResultId' },
  precipitateResultCode: { field: 'code' },
  precipitateResultName: { field: 'precipitateResultName' }
};
